"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatExcessContent = void 0;
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var formatExcessContent = exports.formatExcessContent = function formatExcessContent(_ref) {
  var coverBreakdown = _ref.coverBreakdown,
    productName = _ref.productName,
    label = _ref.label,
    pet = _ref.pet,
    routineCare = _ref.routineCare,
    dental = _ref.dental,
    routineCareValue = _ref.routineCareValue,
    dentalValue = _ref.dentalValue;
  var resultStr = !coverBreakdown ? "".concat(productName, ", ").concat(label, " ").concat((0, _helpers.RoundCurrency)(pet === null || pet === void 0 ? void 0 : pet.selectedQuote.excess)) : '';
  if (!coverBreakdown) {
    if (dental && routineCare) resultStr += " (inc. ".concat(routineCareValue, " and ").concat(dentalValue, ")");
    if (dental && !routineCare) resultStr += " (inc. ".concat(dentalValue, ")");
    if (!dental && routineCare) resultStr += " (inc. ".concat(routineCareValue, ")");
  }
  return resultStr;
};